import { config } from "../Environment";
import { getVisitorId } from "./startFlow";

export type StartEvent =
  | "start_viewed" | "start_routed" | "start_question_answered" | "start_angle_shown"
  | "start_angle_shuffled" | "start_angle_helped" | "start_relief_shown" | "start_deeper_started"
  | "start_step_chosen" | "start_keep_clicked" | "start_kept" | "start_not_now" | "start_distress"
  | "start_checkin_opened" | "start_checkin_completed" | "start_project_created";

/** Fire-and-forget. Never send free text: ids, counts and flags only (spec §7). */
export function trackStart(name: StartEvent, data: Record<string, unknown> = {}): void {
  try {
    fetch(`${config.API_BASE}/api/analytics/event`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        eventName: name,
        eventData: { ...data, visitorId: getVisitorId() },
        timestamp: Date.now(),
        url: window.location.pathname,
      }),
      keepalive: true,
    }).catch(() => {});
  } catch {
    /* analytics must never break the flow */
  }
}
